import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var NormalList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NormalList, _React$Component);

  function NormalList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NormalList.prototype;

  _proto.render = function render() {
    return React.createElement("div", null, React.createElement("h5", {
      className: "title"
    }, this.props.title), React.createElement("ul", {
      className: "items"
    }, this.props.items.map(function (item, index) {
      return React.createElement("li", {
        key: "list-" + index,
        className: "item",
        dangerouslySetInnerHTML: {
          __html: item
        }
      });
    })));
  };

  return NormalList;
}(React.Component);

export default NormalList;